// These polyfills make stable language features of modern ECMAScript
// available accross all target browsers. We include IE11 as it is
// currently still functionally supported for broader web projects
// such as www.ag.ch. Remove or limit these polyfills to reduce build
// if your project allows.
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// IE11 cannot forEach over nodelists
Array.prototype.forEach.call(
  document.querySelectorAll(`[data-${process.env.REACT_APP_NAME}]`),
  (element: HTMLDivElement) => {
    const root = element.shadowRoot
      ? createRoot(element.shadowRoot)
      : createRoot(element);

    root.render(
      React.createElement(App, {
        rootElement: element,
        standalone: element.dataset.standalone === 'true',
        apiUrl: element.dataset.api,
        archiveApiUrl: element.dataset.archiveUrl,
        mapUrl: element.dataset.mapUrl,
        previewUser: element.dataset.previewUser,
        previewPassword: element.dataset.previewPassword,
        translationApiUrl: element.dataset.translationApi,
        translationMissingApiUrl: element.dataset.translationMissingApi,
        navigationCurrent: element.dataset.navigationCurrent,
        navigationSource: element.dataset.navigationSource,
      }),
    );
  },
);
